import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueObject, Result, Guard } from '@digibricks/core';
import { ShuffledAnswerIndex } from './shuffled-answer-index';
export var ShuffledQuestionIndex = /*#__PURE__*/function (_ValueObject) {
  _inherits(ShuffledQuestionIndex, _ValueObject);

  var _super = _createSuper(ShuffledQuestionIndex);

  function ShuffledQuestionIndex() {
    _classCallCheck(this, ShuffledQuestionIndex);

    return _super.apply(this, arguments);
  }

  _createClass(ShuffledQuestionIndex, [{
    key: "index",
    get: function get() {
      return this.props.index;
    }
  }, {
    key: "questionReleaseId",
    get: function get() {
      return this.props.questionReleaseId;
    }
  }, {
    key: "answerIndexes",
    get: function get() {
      return this.props.answerIndexes;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [{
        argument: props.index,
        argumentName: 'question index'
      }, {
        argument: props.questionReleaseId,
        argumentName: 'Question Release Id'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new ShuffledQuestionIndex(props));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var index = data.index,
            questionReleaseId = data.questionReleaseId,
            answerIndexes = data.answerIndexes;
        return this.create({
          index: index,
          questionReleaseId: questionReleaseId,
          answerIndexes: answerIndexes.map(function (a) {
            return ShuffledAnswerIndex.create({
              index: a.index,
              answerId: a.answerId
            }).getValue();
          })
        });
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return ShuffledQuestionIndex;
}(ValueObject);